import aboutImage from "@/assets/images/about-image.jpg";
import { TextButton } from "@/Components/ui/text-button";
import { useTranslation } from "@/hooks/use-translation";

function ImageCard() {
   return (
      <div className="flex-1 overflow-hidden rounded-lg h-64 sm:h-80 md:h-96 lg:h-full">
         <img
            src={aboutImage}
            alt="Nordroof modular home"
            className="w-full h-full object-cover"
            loading="lazy"
         />
      </div>
   );
}

export default function AboutNordroof() {
   const { translation } = useTranslation();
   const { about, learnMore } = translation;

   return (
      <section id="about" className="mt-24 px-4 sm:px-6 lg:px-10">
         {/* header */}
         <div>
            <h6 className="text-d-accent text-custom-dark">{about.title}</h6>
            <h2 className="text-d-h2 text-custom-dark mt-4">
               {about.subtitle}
            </h2>
         </div>

         {/* content */}
         <div className="flex flex-col lg:flex-row gap-5 mt-12 h-auto lg:h-[470px]">
            <ImageCard />

            <div
               className="flex flex-col justify-between bg-custom-light-blue rounded-lg 
             p-6 sm:p-7 lg:p-8
             w-full lg:w-[440px]
             h-auto lg:h-full"
            >
               <h3 className="text-d-h3 text-custom-dark mb-4 lg:mb-0">
                  {about.h3}
               </h3>

               <div className="space-y-4">
                  <p className="text-d-body-m-paragraph text-custom-dark">
                     {about.p}
                  </p>
                  <TextButton variant="cta">{learnMore}</TextButton>
               </div>
            </div>
         </div>
      </section>
   );
}
